import React from 'react';
import Button from '@mui/material/Button';
export const PhoneCall = ({ didTalk }) => {
    return (React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
        React.createElement(Button, { style: { fontFamily: 'Barlow', color: '#00000099', borderRadius: 16, fontWeight: 'bold', fontSize: 'xx-small', cursor: 'auto', backgroundColor: 'transparent' }, color: "inherit", size: "small" }, didTalk)));
};
